export default "__VITE_ASSET__ocNFmFfu__"